import React, {useRef, useEffect} from 'react'

import {questoes} from '../../dados/questoesImagem'

import "./QuestoesImage.css"
import { useAuth } from "../../context/AuthContext";
import { API_URL } from '../../config/api';
export default function QuestoesImage({image, correctAnswer, setCorrectAnswer,ticketId, emitirSom, scoreRecebido, setScoreRecebido}) {

    const svgRef = useRef(null);
    const token = localStorage.getItem('token')
    const {user, setScore, logout} = useAuth()

    const questaoSelecionada = questoes.find(
        (questao) => questao[image]
    )

    const title = questaoSelecionada?.title
    const QuestaoSelecionada = questaoSelecionada?.[image]
    
    const verificaResposta = async(answerId) =>{

         const dados = {
            "userId": user.id,
            "ticketsId": ticketId,
            "answerId": answerId
        };

        console.log("Dados enviados: ",dados)

        await fetch(`${API_URL}/user/answer`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify(dados)
        })
        .then(response => {
             if (response.status === 403) {
                    logout()
                    return
                }

            if (!response.ok) {
                throw new Error(`Erro HTTP: ${response.status}`);
            }

            return response.json();
        })
        .then(data => {
            console.log(data)
            if (data.correct) {
                
                setCorrectAnswer(true);
                setScoreRecebido(data.score);
                setScore(data.scoreTotal)
                emitirSom("certo")
                

            } else {
                setCorrectAnswer(false);
                emitirSom("errado")
            }
            

        })
        .catch(error => {
            console.log("Não foi possível.", error);
        });
    };
    

    useEffect(() => {
        const elementos = svgRef.current?.querySelectorAll('[data-answer]');


        elementos.forEach((elemento) => {
            elemento.addEventListener("click", ()=>{
                const answerId = elemento.dataset.answer
                console.log("ID selecionado: ",answerId)
                verificaResposta(answerId)
            })
        });
    }, []);

    return (
        <div className="questoesImage">
            <h3>{title && title}</h3>
            <QuestaoSelecionada width="50%" height="auto" className={correctAnswer ? "svg erro" :"svg correct"} ref={svgRef} />
        </div>
    );
}








const usuario = {
    nome: "Alfredo",
    email: 'alfredo@appiancapitalbrazil.com'
}

//imprime o nome do usuário no terminal
console.log(usuario.name)


